import { render, staticRenderFns } from "./CalcOfIpoteka.vue?vue&type=template&id=0902cf70&scoped=true&"
import script from "./CalcOfIpoteka.vue?vue&type=script&lang=js&"
export * from "./CalcOfIpoteka.vue?vue&type=script&lang=js&"
import style0 from "./CalcOfIpoteka.vue?vue&type=style&index=0&id=0902cf70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0902cf70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CalcBlockControls: require('/var/www/k9-frontend/k9-front-20261006142511/components/calc-block/CalcBlockControls.vue').default})
